import script from "./BuyStorage.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyStorage.vue?vue&type=script&setup=true&lang=js"

import "./BuyStorage.vue?vue&type=style&index=0&id=1fa3f6bc&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa3f6bc"]])

export default __exports__